<template>
  <div id="ContactPage">
    <v-container grid-list-md>
      <bread-crump-partial header="Kontakt"></bread-crump-partial>
      <v-layout row wrap>
        <v-flex xs12 sm8 md8>
          <div>
            <p>
              <strong>
                Wir freuen uns auf Sie!
              </strong>
            </p>
            <p>
              Haben Sie Fragen oder benötigen Sie weitere Informationen? Wir freuen uns über Ihre Kontaktaufnahme. Ihre Daten werden von
              uns vertraulich behandelt. Wir senden Ihnen gerne mehr Informationen zu oder rufen Sie auf Wunsch zurück.
            </p>

          </div>
        </v-flex>
        <v-flex xs12 sm4 md4>
          <contact-widget></contact-widget>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container>
      <v-layout>
        <v-flex>
          <D3CollisationWidget></D3CollisationWidget>

        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import BreadCrumpPartial from './partials/BreadCrumpPartial'
  import ContactWidget from './widgets/ContactWidget'
  import D3CollisationWidget from './widgets/D3-Collision-Widget.vue'

export default {
    name: 'ContactPage',
    components: {
      BreadCrumpPartial,
      ContactWidget,
      D3CollisationWidget
    },
    data () {
      return {
      }
    },
    methods: {}
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/ContactPage.vue